var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-layout',{attrs:{"column":"","align-space-around":""}},[_c('v-flex',[_c('v-btn',{on:{"click":_vm.signOut}},[_vm._v("Logout")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }